<template>
  <div class="container">
    <div class="sidebar">
      <sidebar-menu />
    </div>
    <div class="right-part">
      <div class="header">
        <top-navigation />
      </div>
      <div class="content">
        <router-view class="router-view-container" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import TopNavigation from "@/components/layout/TopNavigation.vue";
import SidebarMenu from "@/components/layout/SidebarMenu.vue";
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100vh;
  min-width: 1000px;
  display: flex;
  padding: 8px;
  box-sizing: border-box;
  gap: 8px;
  background: #e2e8f0;
}
@media (max-width: 1000px) {
  .container {
    width: calc(100vw - 10px);
    height: calc(100vh - 10px);
  }
}
.sidebar {
  flex: 0 0 220px;
  width: 220px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
}
.right-part {
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
}
.content {
  flex: 1;
  width: 100%;
  overflow-y: auto;
  background: #f4f8fb;
}
.header {
  flex: 0 0 60px;
  width: 100%;
  z-index: 10;
  background: #ffffff;
  border-bottom: 1px solid rgba(8, 145, 178, 0.08);
}
.router-view-container {
  width: 100%;
  height: 100%;
  min-width: 600px;
  display: block;
}
</style>
